import { render, staticRenderFns } from "./AdminMoreImages.vue?vue&type=template&id=f82e6c2e&"
import script from "./AdminMoreImages.vue?vue&type=script&lang=ts&"
export * from "./AdminMoreImages.vue?vue&type=script&lang=ts&"
import style0 from "./AdminMoreImages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports